/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Regionalpricingbadge_Currentprice3Inputs */

const id_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga saat ini`)
};

const ms_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga semasa`)
};

const da_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuværende pris`)
};

const de_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktueller Preis`)
};

const en_us2_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current price`)
};

const es_es2_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio actual`)
};

const es_mx2_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio actual`)
};

const fil_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasalukuyang presyo`)
};

const fr_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix actuel`)
};

const it_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo corrente`)
};

const hu_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuális ár`)
};

const nl_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huidige prijs`)
};

const no_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nåværende pris`)
};

const pl_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualna cena`)
};

const pt_br2_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current price`)
};

const pt_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço atual`)
};

const ro_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preț curent`)
};

const fi_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nykyinen hinta`)
};

const sv_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuvarande pris`)
};

const vi_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá hiện tại`)
};

const tr_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güncel fiyat`)
};

const cs_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuální cena`)
};

const bg_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текуща цена`)
};

const ru_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущая цена`)
};

const uk_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поточна ціна`)
};

const ar_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعر الحالي`)
};

const hi_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान कीमत`)
};

const th_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคาปัจจุบัน`)
};

const ja_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の価格`)
};

const zh_cn2_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current price`)
};

const zh_hant1_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current price`)
};

const ko_components_regionalpricingbadge_currentprice3 = /** @type {(inputs: Components_Regionalpricingbadge_Currentprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current price`)
};

/**
* | output |
* | --- |
* | "Current price" |
*
* @param {Components_Regionalpricingbadge_Currentprice3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_regionalpricingbadge_currentprice3 = /** @type {((inputs?: Components_Regionalpricingbadge_Currentprice3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Regionalpricingbadge_Currentprice3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "ms") return ms_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "da") return da_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "de") return de_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "en-US") return en_us2_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "es-ES") return es_es2_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "es-MX") return es_mx2_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "fil") return fil_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "fr") return fr_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "it") return it_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "hu") return hu_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "nl") return nl_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "no") return no_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "pl") return pl_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "pt-BR") return pt_br2_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "pt") return pt_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "ro") return ro_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "fi") return fi_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "sv") return sv_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "vi") return vi_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "tr") return tr_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "cs") return cs_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "bg") return bg_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "ru") return ru_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "uk") return uk_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "ar") return ar_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "hi") return hi_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "th") return th_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "ja") return ja_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_regionalpricingbadge_currentprice3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_regionalpricingbadge_currentprice3(inputs)
	return ko_components_regionalpricingbadge_currentprice3(inputs)
});
export { components_regionalpricingbadge_currentprice3 as "components.regionalPricingBadge.currentPrice" }